// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".c-content-layout[data-v-6c966926] {\n  --c-content-viewport-height: calc(var(--c-viewport-height) - var(--c-header-height));\n}\n.c-side-ad.c-fullscreen[data-v-6c966926] {\n  display: none;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
